import { Box, Button, Typography } from '@mui/material'
import React from 'react'
import { colors, theme } from './theme'
import { useNavigate } from 'react-router-dom'
import { backendClient } from '../interactors/clients/client'
import { PATHS } from './PATHS'
import { StripeConnectButton } from './Adopters/StripeConnectButton'

export const FreeTrialBanner: React.FC = () => {
  const navigate = useNavigate()

  const trackButtonClick = () => {
    backendClient.post('/customers/tracking', {
      event: 'Clique sur la bannière démarrer adoption',
    })
  }
  return (
    <Box
      sx={{
        backgroundColor: '#FFFF0',
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          maxWidth: '1200px',
          width: '100%',
          textAlign: 'left',
          p: 1.5,
          gap: 2,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'start',
            maxWidth: '65%',
            width: '100%',
          }}
        >
          <Typography sx={{ color: colors.cello, fontWeight: 700, fontSize: { xs: '90%', md: '95%' } }}>
            <Box component="span" sx={{ display: { xs: 'inline', md: 'none' } }}>
              Demandez et g&eacute;rez la r&eacute;ception des frais d&apos;adoption
            </Box>
            <Box component="span" sx={{ display: { xs: 'none', md: 'inline' } }}>
              Demandez et g&eacute;rez la r&eacute;ception des frais d&apos;adoption depuis Petso
            </Box>
          </Typography>
          <Box sx={{ display: { xs: 'none', md: 'block' } }}>
            <Typography sx={{ color: colors.blueSky, fontWeight: 700, fontSize: '79%' }}>
              Indiquez le montant, l&apos;animal et les coordonn&eacute;es de l&apos;adoptant concern&eacute; pour lui
              permettre de r&eacute;gler en ligne.
            </Typography>
            <Typography
              sx={{
                color: colors.blueSky,
                fontWeight: 400,
                fontSize: '72%',
                display: 'flex',
                alignItems: 'center',
                gap: 0.5,
              }}
            >
              <Box
                component="span"
                aria-hidden
                sx={{
                  width: 18,
                  height: 18,
                  borderRadius: '50%',
                  border: `1px solid ${colors.blueSky}`,
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '12px',
                  lineHeight: 1,
                }}
              >
                !
              </Box>
              <Box component="span">
                Jamais utilis&eacute; ? Compl&eacute;tez vos informations aupr&egrave;s de notre partenaire Stripe pour
                percevoir vos r&eacute;glements directement{' '}
                <StripeConnectButton
                  variant="text"
                  color="secondary"
                  content="(ouvrir Stripe)"
                  fullWidth={false}
                  sx={{
                    textTransform: 'none',
                    textDecoration: 'underline',
                    fontSize: 'inherit',
                    fontWeight: 400,
                    minWidth: 'auto',
                    padding: 0,
                  }}
                />
                .
              </Box>
            </Typography>
          </Box>
        </Box>
        <Button
          variant="outlined"
          sx={{
            textTransform: 'none',
            borderRadius: '40px',
            fontWeight: 700,
            fontSize: '15.3px',
            px: { xs: 2.6, md: 3.2 },
            py: { xs: 0.55, md: 0.9 },
            lineHeight: { xs: 1.15, md: 1.3 },
            color: colors.cello,
            borderColor: colors.cello,
            '&:hover': {
              borderColor: colors.cello,
              backgroundColor: theme.palette.primary.light,
            },
          }}
          onClick={() => {
            trackButtonClick()
            navigate(PATHS.ajouterAdoptant.absolute)
          }}
        >
          Demandez un paiement &gt;&gt;
        </Button>
      </Box>
    </Box>
  )
}
